import { render, staticRenderFns } from "./testviews.vue?vue&type=template&id=49232760"
import script from "./testviews.vue?vue&type=script&lang=js"
export * from "./testviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports